import React from 'react';
import './AlertModal.css';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  type?: 'warning' | 'error' | 'info';
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  type = 'warning',
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return '\u274C';
      case 'info':
        return '\u2139\uFE0F';
      default:
        return '\u26A0\uFE0F';
    }
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="alert-modal-backdrop" onClick={handleBackdropClick}>
      <div className={`alert-modal alert-modal-${type}`}>
        <div className="alert-modal-header">
          <span className="alert-modal-icon">{getIcon()}</span>
          <h3 className="alert-modal-title">{title}</h3>
          <button className="alert-modal-close" onClick={onCancel}>
            &times;
          </button>
        </div>
        <div className="alert-modal-content">
          <p>{message}</p>
        </div>
        <div className="alert-modal-actions">
          <button className="alert-modal-button secondary" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button className="alert-modal-button primary" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
